import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { MessageService } from '@klickdata/core/message';
import { MessageErrorComponent } from '@klickdata/core/message/src/message-error/message-error.component';
import { ResourceCategory, ResourceCategoryService, AppScope } from '@klickdata/core/resource';
import { User, UserService } from '@klickdata/core/user';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-user-perosonal-settings-personal-interest',
    templateUrl: './user-perosonal-settings-personal-interest.component.html',
    styleUrls: ['./user-perosonal-settings-personal-interest.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserPerosonalSettingsPersonalInterestComponent implements OnInit, OnDestroy {
    public gamificationCategories$: Observable<ResourceCategory[]>;
    public activeCatsSelection: ResourceCategory[];
    public loadingUserCats: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public onSeachFromList: BehaviorSubject<string> = new BehaviorSubject<string>('');
    @Input() public user: User;
    public destroy: Subject<boolean> = new Subject<boolean>();
    AppScope = AppScope;
    constructor(
        protected categoryService: ResourceCategoryService,
        protected auth: AuthService,
        protected cdr: ChangeDetectorRef,
        protected messageService: MessageService,
        protected userService: UserService
    ) {}

    ngOnInit(): void {
        this.gamificationCategories$ = this.onSeachFromList.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap((query) => this.categoryService.getGamificationCategories(query))
        );

        this.loadingUserCats.next(true);
        this.categoryService
            .getGamificationCategoriesPerUser(this.user.id)
            .pipe(takeUntil(this.destroy))
            .subscribe((cats) => {
                this.activeCatsSelection = cats;
                this.loadingUserCats.next(false);
                this.cdr.markForCheck();
            });

        // this.auth
        //     .getUser()
        //     .pipe(
        //         first(),
        //         takeUntil(this.destroy),
        //         switchMap((user) => {
        //             this.user = user;
        //             this.loadingUserCats.next(true);
        //             return this.categoryService.getGamificationCategoriesPerUser(user.id).pipe(takeUntil(this.destroy));
        //         })
        //     )
        //     .subscribe((cats) => {
        //         this.activeCatsSelection = cats;
        //         this.loadingUserCats.next(false);
        //         this.cdr.markForCheck();
        //     });
    }

    public onSelectedGamCat(category: ResourceCategory) {
        if (this.activeCatsSelection.findIndex((cat) => cat.id === category.id) !== -1) {
            this.messageService.openMessage(MessageErrorComponent, $localize`Category already chosen`);
        } else {
            this.userService
                .update({
                    id: this.user.id,
                    categories_attach: [category.id],
                })
                .pipe(takeUntil(this.destroy))
                .subscribe(() => {
                    this.messageService.openMessage(MessageErrorComponent, $localize`Category added`);
                    this.activeCatsSelection = [...this.activeCatsSelection, category];
                    this.cdr.markForCheck();
                });
        }
    }
    public removeGamCat(category: ResourceCategory) {
        const index = this.activeCatsSelection.findIndex((cat) => cat === category);
        this.userService
            .update({
                id: this.user.id,
                categories_detach: [category.id],
            })
            .pipe(takeUntil(this.destroy))
            .subscribe(() => {
                if (index !== -1) {
                    this.messageService.openMessage(MessageErrorComponent, $localize`Category removed`);
                    this.activeCatsSelection = this.activeCatsSelection.filter((cat) => cat !== category);
                    this.cdr.markForCheck();
                }
            });
    }

    public ngOnDestroy() {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
